import CustomerScreen from './index';
import UserScreen from './detail.user';
import LocationScreen from './detail.location';
import DetailScreen from './detail.index';
import PricingScreen from './detail.pricing';

const routes = [
  {
    path: '/master/customer',
    component: CustomerScreen,
    action: ['manage', 'read_only'],
    service: ['nvo.platform.partner'],
  },
  {
    path: '/master/customer/:id',
    component: DetailScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.platform.partner'],
  },
  {
    path: '/master/customer/:id/pricing',
    component: PricingScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.pricing'],
  },
  {
    path: '/master/customer/:id/user',
    component: UserScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.platform.user'],
  },
  {
    path: '/master/customer/:id/location',
    component: LocationScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.platform.location'],
  },
];

export default routes;
